// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings_settings-content__IiaIL {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);
    width: 100%;
    height: 100vh;
}

.settings_settings-select-container__dhHgb{
    background-color: var(--color-content);
    border-radius: 3px;
    border: 1px solid var(--color-input-border);
    width: 254px;
    height: 35px;
    overflow: hidden;
}

.settings_settings-select__nFkQQ {
    width: 100%;
    height: 100%;
    background: transparent;
    border: 0;
    border-radius: 0;
    color: var(--color-main-typography);
    appearance: none;
    padding: 5px 10px 5px 10px;
    font-size: 12px;
}

.settings_settings-select-arrow__RzRzf {
    position: absolute;
    z-index: 0;
}

.settings_settings-select__nFkQQ:focus {
    outline: none
}

.settings_settings-heading__rziXp {
    margin-top: 30px
}

.settings_mainWrapper__h2VmB {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
}

.settings_rightBlock__iXlNF {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
    color: var(--color-main-typography)
}

.settings_content-container__i0WjC {
    padding: 0;
}


@media screen and (max-width: 1000px) {
    .settings_mainWrapper__h2VmB {
        width: 100%;
    }

    .settings_rightBlock__iXlNF {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .settings_content-container__i0WjC {
        padding: 30px;
    }

    .settings_content-heading-container__QeWIx {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/settings/settings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;IACnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mCAAmC;IAGnC,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[".settings-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n    width: 100%;\n    height: 100vh;\n}\n\n.settings-select-container{\n    background-color: var(--color-content);\n    border-radius: 3px;\n    border: 1px solid var(--color-input-border);\n    width: 254px;\n    height: 35px;\n    overflow: hidden;\n}\n\n.settings-select {\n    width: 100%;\n    height: 100%;\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    color: var(--color-main-typography);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 5px 10px 5px 10px;\n    font-size: 12px;\n}\n\n.settings-select-arrow {\n    position: absolute;\n    z-index: 0;\n}\n\n.settings-select:focus {\n    outline: none\n}\n\n.settings-heading {\n    margin-top: 30px\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n    color: var(--color-main-typography)\n}\n\n.content-container {\n    padding: 0;\n}\n\n\n@media screen and (max-width: 1000px) {\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings-content": `settings_settings-content__IiaIL`,
	"settings-select-container": `settings_settings-select-container__dhHgb`,
	"settings-select": `settings_settings-select__nFkQQ`,
	"settings-select-arrow": `settings_settings-select-arrow__RzRzf`,
	"settings-heading": `settings_settings-heading__rziXp`,
	"mainWrapper": `settings_mainWrapper__h2VmB`,
	"rightBlock": `settings_rightBlock__iXlNF`,
	"content-container": `settings_content-container__i0WjC`,
	"content-heading-container": `settings_content-heading-container__QeWIx`
};
export default ___CSS_LOADER_EXPORT___;
